import _Object$keys from "@babel/runtime-corejs3/core-js-stable/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/filter";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js-stable/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js-stable/object/define-property";
import _extends from "@babel/runtime-corejs3/helpers/extends";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
import _slicedToArray from "@babel/runtime-corejs3/helpers/slicedToArray";
import _objectWithoutProperties from "@babel/runtime-corejs3/helpers/objectWithoutProperties";
var _excluded = ["value", "onChange", "onFocus", "onBlur", "decimalPlaces", "disabled", "id", "testId", "showGrouping", "label", "fieldComponentAriaLabel", "allowNegative"];
function ownKeys(e, r) {
  var t = _Object$keys(e);
  if (_Object$getOwnPropertySymbols) {
    var o = _Object$getOwnPropertySymbols(e);
    r && (o = _filterInstanceProperty(o).call(o, function (r) {
      return _Object$getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
import "core-js/modules/es.regexp.exec.js";
import React, { useCallback, useContext, useMemo, useState } from "react";
import cx from "classnames";
import { getDecimalRegex, isSafeNumber } from "@jutro/data";
import { IntlContext, useTranslator } from "@jutro/locale";
import { isAccessibleDisabled, muteCallbacks } from "../../../accessibleDisabled";
import { IconButton } from "../../IconButton/IconButton_DEPRECATED";
import { messages } from "./InputNumberField.messages";
import styles from "./NumberInput.module.css";
export var NumberInput = function (_ref) {
  var value = _ref.value,
    onChange = _ref.onChange,
    onFocus = _ref.onFocus,
    onBlur = _ref.onBlur,
    decimalPlaces = _ref.decimalPlaces,
    disabled = _ref.disabled,
    id = _ref.id,
    testId = _ref.testId,
    _ref$showGrouping = _ref.showGrouping,
    showGrouping = void 0 === _ref$showGrouping || _ref$showGrouping,
    label = _ref.label,
    fieldComponentAriaLabel = _ref.fieldComponentAriaLabel,
    allowNegative = _ref.allowNegative,
    restProps = _objectWithoutProperties(_ref, _excluded),
    formatNumber = useContext(IntlContext).formatNumber,
    _useState = useState(),
    _useState2 = _slicedToArray(_useState, 2),
    isFocused = _useState2[0],
    setFocused = _useState2[1],
    translator = useTranslator(),
    numericValue = Number(value) || 0,
    step = Number(restProps.step),
    accessibleDisabled = disabled && isAccessibleDisabled("accessibleDisabled.fields"),
    handleValueChange = useCallback(function (event) {
      var _event$target$value,
        _event$target,
        newValue = null !== (_event$target$value = null === (_event$target = event.target) || void 0 === _event$target ? void 0 : _event$target.value) && void 0 !== _event$target$value ? _event$target$value : "";
      isSafeNumber(newValue) && getDecimalRegex(decimalPlaces).test(newValue) && onChange(newValue);
    }, [decimalPlaces, onChange]),
    handleUpArrowClick = useCallback(function () {
      if (!disabled && !accessibleDisabled) {
        var newValue = formatNumber(numericValue + step, {
          maximumFractionDigits: decimalPlaces,
          useGrouping: !1
        });
        (void 0 === restProps.max || newValue <= restProps.max) && onChange(newValue);
      }
    }, [numericValue, step, disabled, accessibleDisabled]),
    handleDownArrowClick = useCallback(function () {
      if (!disabled && !accessibleDisabled) {
        var newValue = formatNumber(numericValue - step, {
          maximumFractionDigits: decimalPlaces,
          useGrouping: !1
        });
        (void 0 === restProps.min || newValue >= restProps.min) && onChange(newValue);
      }
    }, [numericValue, step, disabled, accessibleDisabled]),
    handleOnArrowMouseDown = useCallback(function (event) {
      event.preventDefault();
    }, []),
    handleBlur = useCallback(function (event) {
      setFocused(!1), onBlur(event);
    }, [onBlur]),
    handleFocus = useCallback(function (event) {
      onFocus(event), setFocused(!0);
    }, [onFocus]),
    handleBeforeInput = useCallback(function (event) {
      event.data.match(/^[0-9,-. ]+$/) || event.preventDefault();
    }, []),
    formattedValue = useMemo(function () {
      return value || 0 === value ? formatNumber(value, {
        maximumFractionDigits: decimalPlaces,
        useGrouping: showGrouping
      }) : "";
    }, [decimalPlaces, formatNumber, value, showGrouping]),
    inputAriaLabel = 1 !== step ? translator(messages.numberFieldStepAriaLabel, {
      label: label,
      step: step
    }) : fieldComponentAriaLabel,
    accessibleDisabledProps = accessibleDisabled ? _objectSpread(_objectSpread({}, muteCallbacks(_objectSpread({
      onChange: handleValueChange,
      onBlur: handleBlur,
      onBeforeInput: handleBeforeInput,
      onFocus: handleFocus
    }, restProps))), {}, {
      "aria-disabled": !0,
      "aria-readonly": !0,
      readOnly: !0,
      disabled: void 0,
      role: "spinbutton"
    }) : {},
    nullValue = value || 0 === value ? 0 : "",
    input = value || 0 === value || allowNegative ? React.createElement("input", _extends({
      id: id,
      "data-testid": testId,
      inputMode: "decimal",
      type: isFocused ? "number" : "text",
      value: isFocused ? value || nullValue : formattedValue,
      onChange: handleValueChange,
      onBlur: handleBlur,
      onBeforeInput: handleBeforeInput,
      onFocus: handleFocus,
      disabled: disabled,
      "aria-label": inputAriaLabel
    }, restProps, accessibleDisabledProps)) : React.createElement("input", _extends({
      value: "",
      id: id,
      "data-testid": testId,
      inputMode: "decimal",
      type: "text",
      onChange: handleValueChange,
      onBlur: handleBlur,
      onBeforeInput: handleBeforeInput,
      onFocus: handleFocus,
      disabled: disabled,
      "aria-label": inputAriaLabel
    }, restProps, accessibleDisabledProps));
  return React.createElement("div", {
    className: styles.numberInput
  }, input, isFocused && !accessibleDisabled && React.createElement(React.Fragment, null, React.createElement(IconButton, {
    icon: "gw-arrow-drop-up",
    onMouseDown: handleOnArrowMouseDown,
    onClick: handleUpArrowClick,
    className: cx(styles.numberInputButton, styles.numberInputUp),
    tabIndex: -1,
    ariaLabel: messages.increment,
    noDeprecationWarnings: ["IconButton"]
  }), React.createElement(IconButton, {
    icon: "gw-arrow-drop-down",
    onMouseDown: handleOnArrowMouseDown,
    onClick: handleDownArrowClick,
    className: cx(styles.numberInputButton, styles.numberInputDown),
    tabIndex: -1,
    ariaLabel: messages.decrement,
    noDeprecationWarnings: ["IconButton"]
  })));
};
NumberInput.__docgenInfo = {
  description: "",
  methods: [],
  displayName: "NumberInput",
  props: {
    showGrouping: {
      defaultValue: {
        value: "true",
        computed: !1
      },
      required: !1
    }
  }
}, NumberInput.__docgenInfo = {
  componentName: "NumberInput",
  packageName: "@jutro/components",
  description: "",
  displayName: "NumberInput",
  methods: [],
  actualName: "NumberInput",
  props: {
    showGrouping: {
      defaultValue: {
        value: "true",
        computed: !1
      },
      required: !1
    }
  }
};